import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import Button from 'reusecore/src/elements/Button';
import Card from 'reusecore/src/elements/Card';
import Image from 'gatsby-image';
import Image2 from 'reusecore/src/elements/Image';
import FeatureBlock from 'common/src/components/FeatureBlock';
import Container from 'common/src/components/UI/Container';
import WizyVisionSectionWrapper, {
  BannerObject,
} from './wizyvisionSection.style';
import FeatureImage from 'common/src/assets/image/agency/surface-studio.png';

import BannerObject1 from 'common/src/assets/image/agency/banner/bannerObject1.png';
// import BannerObject2 from 'common/src/assets/image/agency/banner/bannerObject2.png';
import BannerObject2 from 'common/src/assets/image/agency/banner/bannerImage.png';

const WizyVisionSection = ({
  row,
  col,
  title,
  featureCol,
  description,
  textArea,
  imageArea,
  imageAreaRow,
  imageWrapper,
  btnStyle,
  featureTitle,
  featureDescription,
  iconStyle,
}) => {
  const Data = useStaticQuery(graphql`
    query {
      wizyvision: file(
        relativePath: { eq: "image/agency/group/wizyvision-logo.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 505, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      agencyJson {
        qualityFeature {
          description
          icon
          id
          title
        }
      }
    }
  `);

  return (
    <WizyVisionSectionWrapper id="wizyvisionSection">
      <Container>
        <Box className="row" {...row}>
          <Box className="col" {...col} {...textArea}>
            <Box className="col" {...col} {...textArea}>
              <FeatureBlock
                title={
                  <Image
                    imgStyle={{ objectFit: 'contain' }}
                    fluid={Data.wizyvision.childImageSharp.fluid}
                    {...title}
                    className="wv-logo"
                  />
                }
                description={
                  <div>
                    <Heading
                      content="Your Eyes on the Frontline"
                      {...description}
                    />
                    <Text
                      content="Instant collection and processing of Frontline Data using Images & Voice powered by AI"
                      {...description}
                    />
                  </div>
                }
              />
            </Box>
            <Button
              title="LEARN MORE"
              {...btnStyle}
              onClick={() => window.open('https://wizyvision.com')}
            />
          </Box>
        </Box>
      </Container>
      <Container>
        <BannerObject>
          <div className="objectWrapper">
            <Image2 src={BannerObject1} alt="BannerObject1" />
            <div className="dashboardWrapper">
              <Image2 src={BannerObject2} alt="BannerObject2" className="banner-image" />
            </div>
          </div>
        </BannerObject>
      </Container>
    </WizyVisionSectionWrapper>
  );
};

WizyVisionSection.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  featureCol: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
  button: PropTypes.object,
  btnStyle: PropTypes.object,
};

WizyVisionSection.defaultProps = {
  btnStyle: {
    minWidth: '156px',
    fontSize: '14px',
    fontWeight: '500',
  },
  // Quality section row default style
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
  },
  // Quality section iamge row default style
  imageAreaRow: {
    flexDirection: 'row-reverse',
  },
  // Quality section col default style
  col: {
    pr: '15px',
    pl: '15px',
  },
  // Quality feature col default style
  featureCol: {
    width: [1, 1, 1 / 2],
    pr: '15px',
    pl: '15px',
  },
  // Quality section text area default style
  textArea: {
    width: [1, '100%', '100%', '70%', '64%'],
  },
  // Quality section image area default style
  imageArea: {
    width: [1, '100%', '100%', '30%', '38%'],
    flexBox: true,
    flexDirection: 'row-reverse',
  },
  // Quality section image wrapper default style
  imageWrapper: {
    boxShadow: 'none',
    width: '100%',
  },
  // Quality section title default style
  title: {
    fontSize: ['26px', '26px', '32px', '40px'],
    lineHeight: '1.5',
    fontWeight: '300',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '20px',
  },
  // Quality section description default style
  description: {
    fontSize: '16px',
    color: '#343d48cc',
    lineHeight: '2.1',
    mb: '33px',
  },
  // feature icon default style
  iconStyle: {
    width: '54px',
    height: '54px',
    borderRadius: '50%',
    bg: '#93d26e',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    color: '#ffffff',
    overflow: 'hidden',
    mt: '6px',
    mr: '22px',
    flexShrink: 0,
  },
  // feature title default style
  featureTitle: {
    fontSize: ['18px', '20px'],
    fontWeight: '400',
    color: '#0f2137',
    lineHeight: '1.5',
    mb: '8px',
    letterSpacing: '-0.020em',
  },
  // feature description default style
  featureDescription: {
    fontSize: '15px',
    lineHeight: '1.84',
    color: '#343d48cc',
  },
};

export default WizyVisionSection;
